/* eslint-disable react/require-default-props */
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from '../styles/uikitTablesTable.module.scss';

const Table = forwardRef(({
  children = null,
  className = '',
  isFluid = false,
  testId = '',
}, ref) => (
  <table
    className={classnames(
      styles.element,
      {
        [styles.isFluid]: isFluid,
      },
      className,
    )}
    data-testid={testId}
    ref={ref}
  >
    {children}
  </table>
));

Table.displayName = 'Table';

Table.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  testId: PropTypes.string,
  isFluid: PropTypes.bool,
};

export default Table;
